import { render, staticRenderFns } from "./HistoryVisitTab.vue?vue&type=template&id=570d3c8f&scoped=true"
import script from "./HistoryVisitTab.vue?vue&type=script&lang=js"
export * from "./HistoryVisitTab.vue?vue&type=script&lang=js"
import style0 from "./HistoryVisitTab.vue?vue&type=style&index=0&id=570d3c8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570d3c8f",
  null
  
)

export default component.exports